module.exports = __webpack_public_path__ + "static/img/product_images_03_h5_zh.852fb9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_03_h5_zh.png
// module id = qGvU
// module chunks = 34